import {
    grey_900,
    grey_1200,
    green_700,
    green_800,
    green_900,
    blue_700,
    blue_800,
    blue_900,
    purple_700,
    purple_800,
    purple_900,
    orange_700,
    orange_800,
    orange_900,
    yellow_900,
    yellow_800,
    yellow_700,
    teal_900,
    teal_800,
    teal_700,
    red_700,
    red_800,
    red_900,
    pink_700,
    pink_800,
    pink_900,
    pink_1000,
    grey_500,
    pro_900,
    pro_800,
    pro_700,
    business_700,
    business_800,
    business_900,
    colorRisingTalent,
    red_100,
    red_200,
    orange_100,
    orange_200,
    business_500,
    business_400,
    grey_300,
    grey_600,
    red_1100,
    orange_1100,
    grey_400
} from '@fiverr-private/sass/helpers/index';

/**
 * Supported colors.
 * @type {Object<String>}
 */
export const COLORS = {
    GREY: 'grey',
    GREY_1200: 'grey-1200',
    GREEN: 'green',
    BLUE: 'blue',
    PURPLE: 'purple',
    ORANGE: 'orange',
    YELLOW: 'yellow',
    TEAL: 'teal',
    RED: 'red',
    PINK: 'pink',
    PINK_900: 'pink-900',
    LIGHT_GREY: 'light-grey',
    PRO: 'pro',
    BUSINESS: 'business',
    RISING_TALENT: 'rising-talent',
    BUSINESS_400: 'business-400',
    RED_100: 'red-100',
    ORANGE_100: 'orange-100'
} as const;

/**
 * Supported themes.
 * @type {Object<String>}
 */
export const THEMES = {
    FULL: 'full',
    HOLLOW: 'hollow'
} as const;

/**
 * Supported tag sizes.
 * @type {Object<String>}
 */
export const SIZES = {
    TINY: 'tiny',
    SMALL: 'small',
    LARGE: 'large'
} as const;

/**
 * Supported border radiuses.
 * @type {Object<String>}
 */
export const BORDER_RADIUSES = {
    FULL: 'full',
    ROUNDED: 'rounded'
} as const;

export const DISABLED_STYLES = {
    [THEMES.FULL]: {
        backgroundColor: grey_300,
        borderColor: grey_300,
        color: grey_600
    },
    [THEMES.HOLLOW]: {
        borderColor: grey_500,
        color: grey_500
    }
};

export const COLORS_MAP_TO_VALUES = {
    [COLORS.GREY]: {
        default: grey_900,
        hover: grey_900,
        active: grey_900
    },
    [COLORS.GREY_1200]: {
        default: grey_1200,
        hover: grey_1200,
        active: grey_1200
    },
    [COLORS.GREEN]: {
        default: green_700,
        hover: green_800,
        active: green_900
    },
    [COLORS.BLUE]: {
        default: blue_700,
        hover: blue_800,
        active: blue_900
    },
    [COLORS.PURPLE]: {
        default: purple_700,
        hover: purple_800,
        active: purple_900
    },
    [COLORS.ORANGE]: {
        default: orange_700,
        hover: orange_800,
        active: orange_900
    },
    [COLORS.YELLOW]: {
        default: yellow_700,
        hover: yellow_800,
        active: yellow_900
    },
    [COLORS.TEAL]: {
        default: teal_700,
        hover: teal_800,
        active: teal_900
    },
    [COLORS.RED]: {
        default: red_700,
        hover: red_800,
        active: red_900
    },
    [COLORS.PINK]: {
        default: pink_700,
        hover: pink_800,
        active: pink_900
    },
    [COLORS.PINK_900]: {
        default: pink_900,
        hover: pink_900,
        active: pink_1000
    },
    [COLORS.LIGHT_GREY]: {
        [THEMES.HOLLOW]: {
            default: grey_500,
            hover: grey_400,
            active: grey_500,
            textColor: grey_900
        },
        [THEMES.FULL]: {
            default: grey_300,
            hover: grey_400,
            active: grey_500,
            textColor: grey_900
        }
    },
    [COLORS.PRO]: {
        default: pro_700,
        hover: pro_800,
        active: pro_900
    },
    [COLORS.BUSINESS]: {
        default: business_700,
        hover: business_800,
        active: business_900
    },
    [COLORS.RISING_TALENT]: {
        default: colorRisingTalent,
        hover: colorRisingTalent,
        active: colorRisingTalent
    },
    [COLORS.BUSINESS_400]: {
        default: business_400,
        hover: business_400,
        active: business_500
    },
    [COLORS.RED_100]: {
        [THEMES.HOLLOW]: {
            default: red_100,
            hover: red_100,
            active: red_200,
            textColor: red_100
        },
        [THEMES.FULL]: {
            default: red_100,
            hover: red_100,
            active: red_200,
            textColor: red_1100
        }
    },
    [COLORS.ORANGE_100]: {
        [THEMES.HOLLOW]: {
            default: orange_100,
            hover: orange_100,
            active: orange_200,
            textColor: orange_100
        },
        [THEMES.FULL]: {
            default: orange_100,
            hover: orange_100,
            active: orange_200,
            textColor: orange_1100
        }
    }
};

